import React from 'react';
import { useState, useEffect } from 'react';

import { MathJax } from 'better-react-mathjax';

import { Collapse,Button,IconButton,Stack, Container, Typography, Table, TableBody, TableCell, TableContainer, TableRow} from '@mui/material';
import { Nightlight, WbSunny } from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const Cp_list = ['neg. side walls','neg. windward wall','neg. leeward wall (1 > a/b)','neg. leeward wall (4 > a/b > 1)','neg. leeward wall (a/b > 4)','pos. side walls','pos. windward wall','pos. leeward wall (1 > a/b)','pos. leeward wall (4 > a/b > 1)','pos. leeward wall (a/b > 4)','others'];
const Cp_value = [-0.7, -0.8, -0.5,-0.3,-0.2,0.7,0.8,0.5,0.3,0.2,0];

const font_size = window.innerWidth < 500 ? '11px' : '16px';

const Glass = ({ darkMode, triggerDarkMode }) => {

    const [a, setA] = useState(1.44);
    const [b, setB] = useState(4);
    const [tg, setTg] = useState(5.6);
    const [k,setK] = useState(2.86);
    const [m,setM] = useState(7);
    const [E,setE] = useState(71.7);
    const [td,setTd] = useState(3);

    const [Kz,setKz] = useState(1);
    const [G,setG] = useState(0.85);
    const [rho,setRho] = useState(1.2);
    const [Cp,setCp] = useState(-0.8);
    const [Cpi,setCpi] = useState(0.18);

    const [curve_img,setCurveImg] = useState(null);
    const [isloading,setIsloading] = useState(false);
    const [open,setOpen] = useState(false);
    const [isRequest,setIsRequest] = useState(false);
    const [error,setError] = useState(false);
    const [CP_index,setCP_index] = useState(1);
    /*
    useEffect(() => {
        const getlastdata = async () => {
            const response = await fetch('/api/curve/lastdata');
            const data = await response.json();
            console.log(data);
            if (data.success) {
                data.data.a ? setA(data.data.a) : setA(1.44);
                data.data.b ? setB(data.data.b) : setB(4);
                data.data.tg ? setTg(data.data.tg) : setTg(5.6);
                data.data.k ? setK(data.data.k) : setK(2.86);
                data.data.m ? setM(data.data.m) : setM(7);
                data.data.E ? setE(data.data.E) : setE(71.7);
                data.data.td ? setTd(data.data.td) : setTd(3);
                data.data.Kz ? setKz(data.data.Kz) : setKz(1);
                data.data.G ? setG(data.data.G) : setG(0.85);
                data.data.rho ? setRho(data.data.rho) : setRho(1.2);
                data.data.Cp ? setCp(data.data.Cp) : setCp(-0.8);
                data.data.Cpi ? setCpi(data.data.Cpi) : setCpi(0.18);
                data.data.Cp ? setCP_index(Cp_list.indexOf(data.data.Cp)) : setCP_index(1);
                setIsRequest(true);
            } else {
                console.log(data.message);
            }
        }
        getlastdata();
    }, [isRequest]);
    */

    const handleReset = () => {
        setA(1.44);
        setB(4);
        setTg(5.6);
        setK(2.86);
        setM(7);
        setE(71.7);
        setTd(3);
        setKz(1);
        setG(0.85);
        setRho(1.2);
        setCp(-0.8);
        setCpi(0.18);
        setError(false);
        setCP_index(1);
    }

    const handleCalculate = async () => {
        setIsloading(true);
        setCurveImg(null);
        setOpen(false);
        setError(false);
        const _calcdata = {
            a: a,
            b: b,
            tg: tg,
            E: E,
            td: td,
            k: k,    
            m: m,
            Kz: Kz,
            rho: rho,
            G: G,
            Cp: Cp,
            Cpi: Cpi,
            CP_index: CP_index,
        }
        
        const response = await fetch('/api/curve/getcurve', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(_calcdata),
        });
        const data = await response.json();
        console.log(data);
        if (data.success) {
            setCurveImg(data.image);
        } else {
            setError(data.error);
            console.log(data.message);
        }
        setIsloading(false);
    }



    
    return (
        <Container maxWidth="sm" sx={{ pb: '20px', pt: '20px', overflowY: 'auto', height: '100vh', overflowX: 'hidden' }}>
            <Stack
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
            >
                <Stack spacing={0} direction="row" alignItems="center" justifyContent="space-between" minWidth={'100%'}>
                    <Stack spacing={2} direction="column" alignItems="left" justifyContent="left">
                        <Typography variant="h4" style={{ fontSize: '24px', color: darkMode ? 'white' : 'black' }}>Glass Failure <br/>Risk Analysis</Typography>
                    </Stack>
                    <IconButton onClick={() => triggerDarkMode(!darkMode)} style={{ backgroundColor: darkMode ? 'white' : 'black', color: darkMode ? 'black' : 'white' }}>
                        {darkMode ? <WbSunny /> : <Nightlight />}
                    </IconButton>
                </Stack>
                
                <Stack direction="column" alignItems="left" justifyContent="left" minWidth={'100%'} pb={1}>
                    <Typography variant="h6" style={{ fontSize: '20px', color: darkMode ? '#009999' : '#CE0E2D' }}>Input Parameters</Typography>
                </Stack>
                <TableContainer>
                    <Table aria-label="Input Parameter Table">
                        <TableBody>
                            <TableRow>
                                <TableCell sx={{width: '35%'}} size="small" style={{ color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>Parameter</TableCell>
                                <TableCell sx={{width: '25%'}} size="small" style={{ color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>Symbol<br/>(Unit)</TableCell>
                                <TableCell sx={{width: '20%'}} size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>Value</TableCell>
                                <TableCell sx={{width: '20%'}} size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>Modify</TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                    Width
                                </TableCell>
                                <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                    <MathJax
                                    renderMode={"pre"}
                                    typesettingOptions={{ fn: "tex2chtml" }}
                                    text={`b \\ (m)`}
                                    inline
                                    dynamic
                                    />
                                </TableCell>
                                <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                    <MathJax
                                    renderMode={"pre"}
                                    typesettingOptions={{ fn: "tex2chtml" }}
                                    text={`${b.toString()}`}
                                    inline
                                    dynamic
                                    />
                                </TableCell>
                                <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                <input
                                tabIndex={1}
                                step={0.05}
                                max={10}
                                min={0.1}
                                type="number"
                                value={b}
                                onChange={(e) => setB(parseFloat(e.target.value))}
                                style={{ fontSize: font_size, border: '0px solid #CCCCCC', backgroundColor: darkMode ? '#2a2a2a' : 'white' , width: '100%', minHeight: '20px', color: darkMode ? '#CCCCCC' : 'black'}}
                                />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                    Length
                                </TableCell>
                                <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                    <MathJax
                                    renderMode={"pre"}
                                    typesettingOptions={{ fn: "tex2chtml" }}
                                    text={`a \\ (m)`}    
                                    inline
                                    dynamic
                                    />
                                </TableCell>
                                <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                    <MathJax
                                    renderMode={"pre"}
                                    typesettingOptions={{ fn: "tex2chtml" }}
                                    text={`${a.toString()}`}
                                    inline
                                    dynamic
                                    />
                                </TableCell>
                                <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                    <input
                                    tabIndex={2}
                                    step={0.05}
                                    max={10}
                                    min={0.1}
                                    type="number"
                                    value={a}
                                    onChange={(e) => setA(parseFloat(e.target.value))}
                                    style={{ fontSize: font_size, border: '0px solid #CCCCCC', backgroundColor: darkMode ? '#2a2a2a' : 'white' ,width: '100%', minHeight: '20px', color: darkMode ? '#CCCCCC' : 'black'}}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                    Thickness
                                </TableCell>
                                <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                    <MathJax
                                    renderMode={"pre"}
                                    typesettingOptions={{ fn: "tex2chtml" }}
                                    text={`t_g \\ (mm)`}
                                    inline
                                    dynamic
                                    />
                                </TableCell>
                                <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                    <MathJax
                                    renderMode={"pre"}
                                    typesettingOptions={{ fn: "tex2chtml" }}
                                    text={`${tg}`}
                                    inline
                                    dynamic
                                    />
                                </TableCell>
                                <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}> 
                                    <input
                                    tabIndex={3}
                                    step={0.1}
                                    min={1}
                                    type="number"
                                    value={tg}
                                    onChange={(e) => setTg(parseFloat(e.target.value))}
                                    style={{ fontSize: font_size, border: '0px solid #CCCCCC', backgroundColor: darkMode ? '#2a2a2a' : 'white' ,width: '100%', minHeight: '20px', color: darkMode ? '#CCCCCC' : 'black'}}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>

                    <Stack direction="row" spacing={2} justifyContent="left" alignItems="center" mt={1} mb={1}>
                        <Typography variant="h6" style={{ fontSize: '20px', color: darkMode ? '#009999' : '#CE0E2D' }}>Extra Parameters</Typography>
                            <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => setOpen(!open)}
                                sx={{backgroundColor: darkMode ? 'grey' : '#cccccc' , color: darkMode ? 'white' : 'black'}}
                            >
                                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                    </Stack>

                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={{width: '35%'}} size="small" style={{ color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>Parameter</TableCell>
                                    <TableCell sx={{width: '25%'}} size="small" style={{ color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>Symbol<br/>(Unit)</TableCell>
                                    <TableCell sx={{width: '20%'}} size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>Value</TableCell>
                                    <TableCell sx={{width: '20%'}} size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>Modify</TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        Flaw Parameters m
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`m`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`${m? (m < 0.001 ? m.toExponential(0) : m.toFixed(0)) : 'Null' }`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <input
                                        tabIndex={8}
                                        type="number"
                                        value={m}
                                        onChange={(e) => setM(parseFloat(e.target.value))}
                                        style={{ fontSize: font_size, border: '0px solid #CCCCCC', backgroundColor: darkMode ? '#2a2a2a' : 'white' ,width: '100%', minHeight: '20px', color: darkMode ? '#CCCCCC' : 'black'}}
                                        />
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        Flaw Parameters k
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`k \\ (m^{12}N^{-7})`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`${k} \\times 10^{-53}`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <input
                                        tabIndex={4}
                                        step={0.01}
                                        min={2.86}
                                        type="number"
                                        value={k}
                                        onChange={(e) => setK(parseFloat(e.target.value))}
                                        style={{ fontSize: font_size, border: '0px solid #CCCCCC', backgroundColor: darkMode ? '#2a2a2a' : 'white' ,width: '100%', minHeight: '20px', color: darkMode ? '#CCCCCC' : 'black'}}
                                        />
                                    </TableCell>
                                </TableRow>
                                
                                <TableRow>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        Modulus of elasticity
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`E \\ (GPa)`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`${E? (E) : 'Null' }`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <input
                                        tabIndex={5}
                                        min={70}
                                        step={0.1}                                    
                                        type="number"
                                        value={E}
                                        onChange={(e) => setE(parseFloat(e.target.value))}
                                        style={{ fontSize: font_size, border: '0px solid #CCCCCC', backgroundColor: darkMode ? '#2a2a2a' : 'white' ,width: '100%', minHeight: '20px', color: darkMode ? '#CCCCCC' : 'black'}}
                                        />
                                    </TableCell>
                                </TableRow>

                                <TableRow>

                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        Gust wind duration
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`t_d \\ (s)`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`${td? (td < 0.001 ? td.toExponential(1) : td.toFixed(1)) : 'Null' }`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <input
                                        tabIndex={6}
                                        step={0.1}
                                        min={0.1}
                                        type="number"
                                        value={td}
                                        onChange={(e) => setTd(parseFloat(e.target.value))}
                                        style={{ fontSize: font_size, border: '0px solid #CCCCCC', backgroundColor: darkMode ? '#2a2a2a' : 'white' ,width: '100%', minHeight: '20px', color: darkMode ? '#CCCCCC' : 'black'}}
                                        />
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        Density
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`\\rho \\ (kg/m^3)`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`${rho}`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <input
                                        min={0}
                                        step={0.01}
                                        max={1}
                                        tabIndex={7}
                                        type="number"
                                        value={rho}
                                        onChange={(e) => setRho(parseFloat(e.target.value))}
                                        style={{ fontSize: font_size, border: '0px solid #CCCCCC', backgroundColor: darkMode ? '#2a2a2a' : 'white' ,width: '100%', minHeight: '20px', color: darkMode ? '#CCCCCC' : 'black'}}
                                        />
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        Wind pressure <br/>
                                        exposure coefficient
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`K_z`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}> 
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`${Kz}`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <input
                                        min={0}
                                        step={0.01}
                                        max={1}
                                        tabIndex={9}
                                        type="number"
                                        value={Kz}
                                        onChange={(e) => setKz(parseFloat(e.target.value))}
                                        style={{ fontSize: font_size, border: '0px solid #CCCCCC', backgroundColor: darkMode ? '#2a2a2a' : 'white' ,width: '100%', minHeight: '20px', color: darkMode ? '#CCCCCC' : 'black'}}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        Gust effect factor
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`G`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`${G}`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <input
                                        min={0}
                                        step={0.01}
                                        max={1}
                                        tabIndex={10}
                                        type="number"
                                        value={G}
                                        onChange={(e) => setG(parseFloat(e.target.value))}
                                        style={{ fontSize: font_size, border: '0px solid #CCCCCC', backgroundColor: darkMode ? '#2a2a2a' : 'white' ,width: '100%', minHeight: '20px', color: darkMode ? '#CCCCCC' : 'black'}}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>  
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        External pressure <br/>
                                        coefficient
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`C_p`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`${Cp}`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        {CP_index === 10 ? (
                                            <input
                                                type="number"
                                                value={Cp}
                                                step={0.01}
                                                min={-1}
                                                max={1}
                                                onChange={(e) => setCp(parseFloat(e.target.value))}
                                                style={{ fontSize: font_size, border: '0px solid #CCCCCC', backgroundColor: darkMode ? '#2a2a2a' : 'white' ,width: '100%', minHeight: '20px', color: darkMode ? '#CCCCCC' : 'black'}}
                                            />
                                        ) : (
                                            <select 
                                            size="small"
                                            value={Cp_value.indexOf(Cp)}
                                            onChange={(e) => {setCp(Cp_value[e.target.value]);setCP_index(e.target.value)}}
                                            style={{ fontSize: font_size, border: '0px solid #CCCCCC', backgroundColor: darkMode ? '#2a2a2a' : 'white' ,width: '100%', minHeight: '20px', color: darkMode ? '#CCCCCC' : 'black'}}
                                        >
                                            {Cp_list.map((item, index) => (
                                                <option key={index} value={index}>{item}</option>
                                            ))}
                                        </select>
                                        )}
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        Internal pressure <br/>
                                        coefficient
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`C_{pi}`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={`${Cpi.toFixed(4)}`}
                                        inline
                                        dynamic
                                        />
                                    </TableCell>
                                    <TableCell size="small" style={{color: darkMode ? 'white' : 'black', border: '1px solid #CCCCCC', fontSize: font_size}}>
                                        <input
                                        min={0}
                                        step={0.01}
                                        max={1}
                                        tabIndex={12}
                                        type="number"
                                        value={Cpi.toFixed(4)}
                                        onChange={(e) => setCpi(parseFloat(e.target.value))}
                                        style={{ fontSize: font_size, border: '0px solid #CCCCCC', backgroundColor: darkMode ? '#2a2a2a' : 'white' ,width: '100%', minHeight: '20px', color: darkMode ? '#CCCCCC' : 'black'}}
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Collapse>
                </TableContainer>
                
                <Stack direction="row" spacing={2} justifyContent="center" alignItems="center" mt={2}>
                    <Button variant="contained" onClick={() => handleCalculate()} sx={{backgroundColor: darkMode ? '#3f50b5' : '#3f50b5' , color: darkMode ? 'white' : 'black'}}>Plot</Button>
                    <Button variant="contained" onClick={() => handleReset()} sx={{backgroundColor: darkMode ? 'grey' : 'grey' , color: darkMode ? 'white' : 'black'}}>Reset</Button>
                </Stack>
                {curve_img && !isloading ? (
                    <Stack direction="row" spacing={2} justifyContent="center" alignItems="center" mt={2}>
                        <img 
                            src={`data:image/png;base64,${curve_img}`}
                            alt="Probability Curve"
                            style={{ maxWidth: '100%', height: 'auto' }}
                        />
                    </Stack>
                ) : isloading ? (
                    <Stack direction="row" spacing={2} justifyContent="center" alignItems="center" mt={2}>
                        <CircularProgress />
                    </Stack>
                ) : error ? (
                    <Stack direction="row" spacing={2} justifyContent="center" alignItems="center" mt={2}>
                        <Typography variant="h6" style={{ color: 'red' }}>Error: {error}</Typography>
                    </Stack>
                ) : null}
            </Stack>
        </Container>
    );
};

export default Glass;
